import { calculateArchiveStats } from '../controllers/archive'
import { generateArchivePromoMessage } from '../util/generateArchivePromoMessage'
import { getNextUnattemptedArchivePuzzleNumber } from '../util/getNextUnattemptedArchivePuzzleNumber'
import { useLocation } from 'wouter'
import ArchiveIcon from './Icon/ArchiveIcon'
import logGoogleEvent from '../util/logEvent'

const ArchivePromoCard = () => {
	const [, navigate] = useLocation()

	//Need to recalculate if player returns to daily page
	const archivePuzzle = getNextUnattemptedArchivePuzzleNumber()
	const stats = calculateArchiveStats()

	const { title, subText, completionMessage } = generateArchivePromoMessage(
		stats.completedPercent,
		stats.available
	)

	return (
		<div className="archive-promo-card box">
			<h2>{title}</h2>
			<ArchiveIcon />
			<p>{subText}</p>
			<button
				className="button promo-button"
				onClick={() => {
					logGoogleEvent('archivepromo_click')
					navigate(`/archive/daily/${archivePuzzle}`)
				}}
			>
				{stats.completedPercent === 100 ? 'Play Again' : 'Play'}
			</button>
			<p>
				{stats.completedPercentStr} completed. {completionMessage}
			</p>
		</div>
	)
}

export default ArchivePromoCard
